import axios from 'axios';
// 타임아웃 30초, 백엔드와 통일
// https://barogo.slack.com/archives/C04UP4VFCKA/p1698984632792479?thread_ts=1698984150.882059&cid=C04UP4VFCKA
const timeout = 30000;
const authInstance = axios.create({
    baseURL: process.env.BASE_OAUTH_SERVER_URL,
    timeout,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    validateStatus: (status) => status < 300,
});
const clientInstance = axios.create({
    baseURL: process.env.BASE_CLIENT_API_SERVER_URL,
    timeout,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
    },
    validateStatus: (status) => status < 300,
});
// vworld 동경계 기능 https://www.vworld.kr/v4po_main.do
const vworldDataInstance = axios.create({
    baseURL: process.env.BASE_VWORLD_API_SERVER_URL,
    timeout,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
    },
    validateStatus: (status) => status < 300,
});
const mockDataInstance = axios.create({
    // baseURL: 'https://bbe03e1e-822e-4115-9562-2eff5bfe9ee1.mock.pstmn.io', (worker)
    baseURL: 'https://a524d78d-558f-4975-957d-09380dd22bda.mock.pstmn.io',
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
    },
    validateStatus: (status) => status < 300,
});
export { authInstance, clientInstance, vworldDataInstance, mockDataInstance, };
